import type { MessageKey } from 'types/LocaleMessageKey';

const perimenopauseAccordionData = [
  {
    id: 'peri-faq-1',
    header: 'perimenopause_faq_title_1',
    content: 'perimenopause_faq_answer_1',
    href: '/sleep-and-rest',
  },
  {
    id: 'peri-faq-2',
    header: 'perimenopause_faq_title_2',
    content: 'perimenopause_faq_answer_2',
    href: '/womens-health',
  },
  {
    id: 'peri-faq-3',
    header: 'perimenopause_faq_title_3',
    content: 'perimenopause_faq_answer_3',
    blogHref: 'readiness-score',
    target: '_blank',
  },
  {
    id: 'peri-faq-4',
    header: 'perimenopause_faq_title_4',
    content: 'perimenopause_faq_answer_4',
    href: '/stress',
  },
  {
    id: 'peri-faq-5',
    header: 'perimenopause_faq_title_5',
    content: 'perimenopause_faq_answer_5',
    href: '/metabolic-health',
  },
] as {
  id: string;
  header: MessageKey;
  content: MessageKey;
  href?: string;
  blogHref?: string;
  target?: string;
}[];

export default perimenopauseAccordionData;
